var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container"},[_c('div',{staticClass:"speed"},[_vm._v(" "+_vm._s(_vm.speed)+" ")]),_c('div',{staticClass:"speed-limit"},[_vm._v(" "+_vm._s(_vm.speedLimit)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }